/**
 * Sentry (H6) — web side. DSN 미설정 시 graceful no-op.
 * Vite env: VITE_SENTRY_DSN (build time).
 */
import * as Sentry from '@sentry/browser';

let initialized = false;

export function initSentry(): void {
  if (initialized) return;
  const dsn = (import.meta as ImportMeta).env?.VITE_SENTRY_DSN as string | undefined;
  const env = (import.meta as ImportMeta).env?.MODE ?? 'development';
  if (!dsn) {
    console.log('[sentry] DSN not set → disabled (graceful no-op)');
    initialized = true;
    return;
  }
  Sentry.init({
    dsn,
    environment: env,
    tracesSampleRate: env === 'production' ? 0.1 : 0,
    sendDefaultPii: false,
  });
  initialized = true;
}

export function captureException(err: unknown, ctx?: Record<string, unknown>): void {
  const dsn = (import.meta as ImportMeta).env?.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;
  if (ctx) Sentry.withScope((scope) => {
    for (const [k, v] of Object.entries(ctx)) scope.setExtra(k, v);
    Sentry.captureException(err);
  });
  else Sentry.captureException(err);
}
